import { connect } from 'react-redux'
import { setSelectedProduct } from 'shared/pages/Company/module'
import {
  getGroupedResults,
  getSearchBarResultsRequest,
  resetSearchResults,
  selectSearchResult,
  setGroupedResultsKey } from './module'
import SearchBar from './SearchBar.component'

function mapStateToProps (state) {
  return {
    isNoResultsVisible: state.searchBar.isNoResultsVisible,
    query: state.searchBar.query,
    results: setGroupedResultsKey(getGroupedResults(state)),
    location: state.routing.location.pathname
  }
}

function mapDispatchToProps (dispatch) {
  return {
    getSearchBarResults (query) {
      dispatch(getSearchBarResultsRequest(query))
    },
    selectSearchResult (id, name, type) {
      dispatch(selectSearchResult(id, name, type))
    },
    resetSearchBarResults () {
      dispatch(setSelectedProduct(null))
      dispatch(resetSearchResults())
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SearchBar)
